import React from 'react';
import { Tooltip, Typography } from 'antd';
import { ClockCircleTwoTone } from '@ant-design/icons';
import { IRequest } from 'common/schema/request/Request';
import { RequestLogic } from 'common/schema/RequestLogic';
import { IProcedure } from 'common/schema/Procedure';
const { Text } = Typography;

export interface IRequestPointsItemProps {
  request: IRequest;
  procedure: IProcedure | null | undefined;
}

export function RequestPointsItem(props: IRequestPointsItemProps) {
  const { request, procedure } = props;
  const { rules, commission, total } = RequestLogic.getPoints(request);
  return (
    <span>
      <Text strong>{total} </Text>
      <Text type="secondary">
        {' '}
        ( {rules} + {commission} )
      </Text>{' '}
      {procedure?.pointAssignmentType && !request.totalCommissionPoints ? (
        <Tooltip title="La valutazione è ancora in corso">
          <ClockCircleTwoTone twoToneColor="#faad14" />
        </Tooltip>
      ) : null}
    </span>
  );
}
